module.exports = __webpack_public_path__ + "files/ab9d0dab55c1556ca3b35365363d79d3.png";